import React,{useState} from 'react'
import { Input } from 'antd';
import {validateInput} from '../Validators/Validators'
import {AiOutlineInfoCircle} from 'react-icons/ai'

function InputField({type,placeholder,error_obj,validators,onChange,name,nameerr,value,priority,size}) {
    const [error, setError] = useState({});
   
    const handleChange = (event) => {
        const {value} = event.target;
        setError(validateInput(validators, value));
        onChange({value:value,key:name,name_err:nameerr});

    };



    return (
        <div>
            <Input size={size === null || size=== undefined ? "medium": size} value={value}    style={{borderLeft:priority === 'high' && '4px solid #292961',borderRadius:'5px'}} type={type} placeholder={placeholder} onChange={handleChange}  />
            <div style={{display:'flex',alignItems:'center',marginTop:'3px'}}>
               {(error?.error || error_obj?.error) && <AiOutlineInfoCircle size={14} style={{color:'red'}}/>  }
              <p style={{marginBottom:'0px',fontSize:'12px',color:'red',paddingLeft:'3px'}}>{error?.message || error_obj?.message }</p>
            </div> 
        </div>
    )
}

export default InputField
